export default {"src":"/_next/static/media/squareOutline.b730fd65.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};